module.exports = __webpack_public_path__ + "assets/images/invisible-asia/7-japan.jpg?v=0d1ab49f";